export default "__VITE_PUBLIC_ASSET__f90f7498__"